import React from "react";
import { Avatar, Button, PopoverTrigger } from "@chakra-ui/react";
import { getImageUrl } from "duck";
import { Author } from "../../duck";

interface MarkButtonProps {
  isOpen: boolean;
  author: Author;
}

const MarkButton: React.FC<MarkButtonProps> = ({ isOpen, author }) => {
  const fullName = `${author.firstName} ${author.lastName}`;

  return (
    <PopoverTrigger>
      <Button
        zIndex={isOpen ? 4 : 3}
        w={6}
        h={10}
        borderRadius="50%"
        borderBottomLeftRadius="initial"
        p={0}
        variant="unstyled"
        backgroundColor="white"
        boxShadow="base"
        _active={{
          backgroundColor: "basic.500"
        }}
        isActive={isOpen}
      >
        <Avatar
          size="sm"
          name={fullName}
          src={author?.image?._id ? getImageUrl(author.image._id) : undefined}
        />
      </Button>
    </PopoverTrigger>
  );
};

export default MarkButton;
